// extracted by mini-css-extract-plugin
export default {"image":"sY-z","loaded":"tY-z"};